/**
 * @typedef {"Main" | "Group" | "Target" | "Container"} TorusClassesNamesProps
 */

import auto from "./src/auto";
import destroy from "./src/destroy";
import reload from "./src/reload";
import init from "./src/manual";
import Main from "./src/Main/Main";
import Group from "./src/Group/Group";
import Container from "./src/Container/Container";
import { G_elements } from "./src/utils/globals/elements";
import beforeMutation from "./src/utils/initialization/before-mutations";
import afterInit from "./src/Main/listeners/events/after-init";
import WINDOW from "./src/utils/window";
import initInitials from "./src/Main/listeners/utils/init-initials";

const elements = G_elements;
const win = /** @type {Window & { TORUS: TorusNamespace }} */ (
  /** @type {unknown} */ (window)
);

win.TORUS = {
  init,
  destroy,
  reload,
  beforeMutation,
  afterInit,
  initInitials,
  Main,
  Group,
  Container,
  elements,
  WINDOW,
};

auto();

export {
  init,
  destroy,
  reload,
  beforeMutation,
  afterInit,
  initInitials,
  Main,
  Group,
  Container,
  elements,
  WINDOW,
};
